import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionsLists } from 'vopay';
import useFetchBillPayTransaction from '@/hooks/useApi/useFetchBillPayTransaction';
import BillPayInfo from './BillPayInfo';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type BillPayContainerProps = {
  TransactionID: string;
  parentTransaction?: TransactionsLists;
} & Omit<ComponentProps<typeof BillPayInfo>, 'transaction' | 'parentTransaction'>;

export default function BillPayContainer({ TransactionID, jwt, parentTransaction, ...props }: BillPayContainerProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { fetchBillPayTransaction, details } = useFetchBillPayTransaction({ bearer: jwt });

  useEffect(() => {
    blockingLoader.show();

    fetchBillPayTransaction({ TransactionID })
      .catch((error) => {
        // Not returned: the dialog's promise settles on dismissal, and the loader must drop before that.
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred'));
      })
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  return (
    <div>
      {details && <BillPayInfo transaction={details} jwt={jwt} parentTransaction={parentTransaction} {...props} />}
    </div>
  );
}
